<template>
    <div>
      <!-- Unavailable: no provider/facility context set -->
      <div v-if="(!targetDoctorId && !targetFacilityId)" class="mt-2 text-gray-400">
        当前医生暂未开放在线预约，请稍后再试或联系诊所人工预约。
      </div>

      <!-- Slots and messages (only when context exists) -->
      <template v-else>
        <div v-if="slotsStatus === 'loading'" class="mt-2 text-gray-400" aria-live="polite">
          正在加载可预约时段，请稍候…
        </div>
        <div v-else-if="slotsStatus === 'error'" class="mt-2 text-gray-400" aria-live="polite">
          当前在线预约服务暂时不可用，请稍后重试或联系诊所。
        </div>
        <div v-else-if="AppointmentSlots.length > 0" class="mt-4 mb-6 sm:mt-0" aria-live="polite">
          <p class="text-center mb-2 lg:mb-4 lg:text-lg">
            {{doctorDetails.provider.cn_name}}{{doctorDetails.provider.cn_specialty_1}}医生诊所 <span class="font-bold">{{ selectedApptDate }}</span> 可请求预约的时间段如下：
          </p>
          <div class="grid grid-cols-4 gap-4 md:grid-cols-5 ">
            <div v-for="slot in AppointmentSlots" :key="slot.slot_start_ts">
              <DoctorSchedulerTimePickerSlot :SlotObj="slot" />
            </div>
          </div>
        </div>
        <div v-else class="mt-2 text-gray-400" aria-live="polite">
          如您选择的日期没有可请求预约的时间段，您可稍后刷新本页面重试或选择其他日期。
        </div>
      </template>

    <!-- <a v-else-if="doctorDetails.provider.tier === 'tier3' || doctorDetails.provider.tier === 'tier4' || doctorDetails.provider.tier === 'tier4-founder'" :href="`tel:${doctorDetails.provider.telephone}`" class="border border-transparent text-sm font-semibold text-primaryText mt-4 block">
      <PhoneIcon class="h-5 w-5 text-primaryColor/70 inline" aria-hidden="true" />
      24小时客服
    </a> -->
  
  
    
      <div v-if="!route.fullPath.includes('/appointment') && selectedAppointmentSlot != ''">
       
            <NuxtLink :to="`/doctor/${doctorDetails.provider.cn_specialty_1}/${doctorDetails.provider.cn_name}/appointment`" @click="onCountApptBtnClicked()" type="button" class="mt-2 content-center rounded-md bg-primaryBtn px-3 py-2 text-md font-semibold text-white shadow-sm hover:bg-white  hover:text-primaryBtn focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">继续预约</NuxtLink>
        
      </div>
      <!-- {{typeof(AppointmentSlots)}} -->
      <!-- Selected Appt. Date and Slot: {{ selectedApptDate }} {{ selectedAppointmentSlot }} -->
    </div>
</template>
  
<script setup>
/**
 * Component: DoctorSchedulerTimePicker
 * Purpose: Render available time slots and allow users to select one
 * - Shows an unavailable message when scheduling context is not ready
 * - Delegates slot fetching and selection to usePatientAppointmentRequest
 */
import { useToast } from 'vue-toastification'
import {PhoneIcon} from "@heroicons/vue/20/solid/index.js";
const toast = useToast()
const {
    targetDoctorId, targetFacilityId, targetDateTime, ptData, submitAppointmentRequest, selectedApptDate, getAppointmentSlots, AppointmentSlots, setAppointmentSlots, selectedAppointmentSlot, setSelectedAppointmentSlot, slotsStatus
} = usePatientAppointmentRequest()

const { doctorDetails } = useSearch()

const route = useRoute()
const router = useRouter()
onMounted(async () => {
  // React to date changes
  watch(selectedApptDate, (new_datestr, old_datestr) => {
    if (old_datestr == "") {
      console.log ( `Target Appointment Date Updated from ${old_datestr} to ${new_datestr}, first initilization.`)
      getAppointmentSlots(false)
    } else {
      console.log ( `Target Appointment Date Updated from ${old_datestr} to ${new_datestr}`)
      getAppointmentSlots(true)
    }
  })

  // Also refetch when provider/facility context becomes available after initial mount
  watch([targetDoctorId, targetFacilityId], (vals, prev) => {
    const [docId, facId] = vals
    if (docId && facId && selectedApptDate.value) {
      getAppointmentSlots(false)
    }
  }, { immediate: false })

  // Ensure initial fetch even if selected date and context were set before watcher registration
  if ((targetDoctorId.value || targetFacilityId.value) && selectedApptDate.value) {
    getAppointmentSlots(false)
  }
})

const onCountApptBtnClicked = () => {

  toast.warning('可用预约时间发生变化，您检查预约时间',{
    position: 'bottom-center',
  })
 
}
  
  
  
  
  </script>
  